(function() {
  function initCarousel(carousel) {
    const sectionId = carousel.getAttribute('data-carousel-id');
    if (!sectionId) return;

    const slides = carousel.querySelectorAll('.columbia-carrusel-text-img-slide');
    if (slides.length === 0) return;

    const dotsContainerMobile = document.getElementById('columbia-carrusel-text-img-dots-mobile-' + sectionId);
    const dotsContainerDesktop = document.getElementById('columbia-carrusel-text-img-dots-desktop-' + sectionId);
    var containerEl = carousel.closest('.columbia-carrusel-text-img-carousel-container');
    var centerWhenNoCarousel = containerEl && containerEl.getAttribute('data-center-when-no-carousel') === 'true';

    let currentIndex = 0;
    const totalSlides = slides.length;
    let visibleSlides = 1;

    function getGap() {
      const width = window.innerWidth;
      if (width <= 425.98) return 15;
      if (width <= 768) return 12;
      if (width <= 1024) return 12;
      if (width <= 1280) return 14;
      if (width <= 1440) return 16;
      if (width <= 1600) return 18;
      return 20;
    }

    /** Ancho visible del carrusel (excluye padding del contenedor para que el último slide se vea completo) */
    function getContainerContentWidth() {
      const container = carousel.closest('.columbia-carrusel-text-img-carousel-container');
      if (!container) return window.innerWidth;
      const full = container.offsetWidth;
      const style = window.getComputedStyle(container);
      const pl = parseFloat(style.paddingLeft) || 0;
      const pr = parseFloat(style.paddingRight) || 0;
      return full - pl - pr;
    }

    function getSlideWidth() {
      const width = window.innerWidth;
      if (width <= 425.98) return Math.min(284, Math.max(240, width * 0.56471));
      if (width <= 768) return Math.min(284, Math.max(240, width * 0.3125));
      if (width <= 1024) return 250;
      if (width <= 1280) return 260;
      if (width <= 1440) return 270;
      if (width <= 1600) return 280;
      return 293;
    }

    function calculateVisibleSlides() {
      const container = carousel.closest('.columbia-carrusel-text-img-carousel-container');
      if (!container) return 1;
      const slideWidth = (slides[0] && slides[0].offsetWidth) ? slides[0].offsetWidth : getSlideWidth();
      const gap = getGap();
      const containerWidth = getContainerContentWidth();
      return Math.max(1, Math.floor((containerWidth + gap) / (slideWidth + gap)));
    }

    function getMaxIndex() {
      const container = carousel.closest('.columbia-carrusel-text-img-carousel-container');
      if (!container || totalSlides === 0) return 0;

      const slideWidth = (slides[0] && slides[0].offsetWidth) ? slides[0].offsetWidth : getSlideWidth();
      const gap = getGap();
      const containerWidth = getContainerContentWidth();
      const isMobile = window.innerWidth <= 768;
      const visibleSlidesCount = Math.floor((containerWidth + gap) / (slideWidth + gap));
      const totalCarouselWidth = (totalSlides * slideWidth) + ((totalSlides - 1) * gap);
      if (isMobile && visibleSlidesCount === 1) {
        return Math.max(0, totalSlides - 1);
      }

      if (totalCarouselWidth <= containerWidth) return 0;

      let maxIndex = Math.max(0, totalSlides - visibleSlidesCount);
      const lastSlideIndex = totalSlides - 1;
      const lastSlidePosition = lastSlideIndex * (slideWidth + gap);
      const translateAtMax = maxIndex * (slideWidth + gap);
      const lastSlideVisibleEnd = translateAtMax + containerWidth;
      const lastSlideActualEnd = lastSlidePosition + slideWidth;

      if (lastSlideActualEnd < lastSlideVisibleEnd) {
        const excessSpace = lastSlideVisibleEnd - lastSlideActualEnd;
        const excessIndex = Math.ceil(excessSpace / (slideWidth + gap));
        maxIndex = Math.max(0, maxIndex - excessIndex);
      }
      /* When content overflows, allow at least one scroll step (maxIndex >= 1) so dots/drag work */
      if (totalCarouselWidth > containerWidth && maxIndex < 1) maxIndex = 1;

      return Math.min(maxIndex, totalSlides - 1);
    }

    function getCurrentTranslateX() {
      const transform = carousel.style.transform;
      if (!transform || transform === 'none') return 0;
      const match = transform.match(/translateX\((-?\d+\.?\d*)px\)/);
      return match ? parseFloat(match[1]) : 0;
    }

    function getSlideIndexFromTranslateX(translateX) {
      const slideWidth = (slides[0] && slides[0].offsetWidth) ? slides[0].offsetWidth : getSlideWidth();
      const gap = getGap();
      const maxIndex = getMaxIndex();
      const isMobile = window.innerWidth <= 768;
      const index = Math.round(-translateX / (slideWidth + gap));
      if (isMobile && visibleSlides === 1) {
        return Math.max(0, Math.min(index, totalSlides - 1));
      }
      return Math.max(0, Math.min(index, maxIndex));
    }

    function updateDotsMobile() {
      if (!dotsContainerMobile || window.innerWidth > 768) return;
      const dots = dotsContainerMobile.querySelectorAll('.columbia-carrusel-text-img-dot-mobile');
      dots.forEach(function(dot) {
        const slideIndex = parseInt(dot.getAttribute('data-slide-index'), 10);
        if (slideIndex === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    function getDesktopActiveDotIndex(numDots) {
      const maxIndex = getMaxIndex();
      if (maxIndex <= 0) return 0;
      if (numDots === 2) {
        return currentIndex <= maxIndex / 2 ? 0 : 1;
      }
      const third = maxIndex / 3;
      if (currentIndex < third) return 0;
      if (currentIndex < 2 * third) return 1;
      return 2;
    }

    function renderDesktopDots() {
      if (!dotsContainerDesktop || window.innerWidth <= 768 || totalSlides <= 3 || getMaxIndex() <= 0) {
        if (dotsContainerDesktop) dotsContainerDesktop.innerHTML = '';
        return;
      }
      var numDots = totalSlides === 5 ? 2 : 3;
      var ariaLabels = numDots === 2 ? ['Ir al inicio', 'Ir al final'] : ['Ir al inicio', 'Ir al centro', 'Ir al final'];
      if (dotsContainerDesktop.children.length !== numDots) {
        dotsContainerDesktop.innerHTML = '';
        for (var i = 0; i < numDots; i++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'columbia-carrusel-text-img-dot-desktop';
          btn.setAttribute('data-dot-index', i);
          btn.setAttribute('aria-label', ariaLabels[i]);
          (function(dotIndex, isTwoDots) {
            btn.addEventListener('click', function(e) {
              e.preventDefault();
              var maxIdx = getMaxIndex();
              var targetIndex;
              if (isTwoDots) {
                targetIndex = dotIndex === 0 ? 0 : maxIdx;
              } else {
                if (dotIndex === 0) targetIndex = 0;
                else if (dotIndex === 1) targetIndex = maxIdx <= 1 ? 1 : Math.floor(maxIdx / 2);
                else targetIndex = maxIdx;
              }
              goToSlide(targetIndex);
            });
          })(i, numDots === 2);
          dotsContainerDesktop.appendChild(btn);
        }
      }
      var desktopDots = dotsContainerDesktop.querySelectorAll('.columbia-carrusel-text-img-dot-desktop');
      var activeDot = getDesktopActiveDotIndex(numDots);
      desktopDots.forEach(function(dot, i) {
        if (i === activeDot) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    var arrowLeft = containerEl ? containerEl.querySelector('.columbia-carrusel-text-img-arrow--left') : null;
    var arrowRight = containerEl ? containerEl.querySelector('.columbia-carrusel-text-img-arrow--right') : null;

    function updateArrows() {
      if (!arrowLeft || !arrowRight || window.innerWidth <= 768) return;
      if (totalSlides <= 3) {
        arrowLeft.classList.add('columbia-carrusel-text-img-arrow--hidden');
        arrowRight.classList.add('columbia-carrusel-text-img-arrow--hidden');
        return;
      }
      var maxIndex = getMaxIndex();
      var container = carousel.closest('.columbia-carrusel-text-img-carousel-container');
      var slideWidth = (slides[0] && slides[0].offsetWidth) ? slides[0].offsetWidth : getSlideWidth();
      var gap = getGap();
      var containerWidth = getContainerContentWidth();
      var totalCarouselWidth = (totalSlides * slideWidth) + ((totalSlides - 1) * gap);
      var noOverflow = totalCarouselWidth <= containerWidth;

      if (noOverflow || maxIndex <= 0) {
        arrowLeft.classList.add('columbia-carrusel-text-img-arrow--hidden');
        arrowRight.classList.add('columbia-carrusel-text-img-arrow--hidden');
        return;
      }
      if (currentIndex <= 0) {
        arrowLeft.classList.add('columbia-carrusel-text-img-arrow--hidden');
      } else {
        arrowLeft.classList.remove('columbia-carrusel-text-img-arrow--hidden');
      }
      if (currentIndex >= maxIndex) {
        arrowRight.classList.add('columbia-carrusel-text-img-arrow--hidden');
      } else {
        arrowRight.classList.remove('columbia-carrusel-text-img-arrow--hidden');
      }
    }

    function updateCarousel() {
      visibleSlides = calculateVisibleSlides();
      const maxIndex = getMaxIndex();
      const isMobile = window.innerWidth <= 768;

      if (isMobile && visibleSlides === 1) {
        if (currentIndex >= totalSlides) currentIndex = Math.max(0, totalSlides - 1);
      } else {
        if (currentIndex > maxIndex) currentIndex = maxIndex;
        if (currentIndex >= totalSlides) currentIndex = Math.max(0, totalSlides - 1);
      }

      const slideWidth = (slides[0] && slides[0].offsetWidth) ? slides[0].offsetWidth : getSlideWidth();
      const gap = getGap();
      const container = carousel.closest('.columbia-carrusel-text-img-carousel-container');
      const containerWidth = getContainerContentWidth();
      const totalCarouselWidth = (totalSlides * slideWidth) + ((totalSlides - 1) * gap);
      const maxTranslateX = -(totalCarouselWidth - containerWidth);
      const minTranslateX = (totalCarouselWidth <= containerWidth) ? 0 : maxTranslateX;

      let translateX;
      if (isMobile && visibleSlides === 1 && currentIndex >= totalSlides - 1 && totalSlides > 1) {
        translateX = maxTranslateX;
      } else if (!isMobile && currentIndex >= maxIndex && maxIndex > 0) {
        translateX = maxTranslateX;
      } else {
        translateX = -(currentIndex * (slideWidth + gap));
      }
      translateX = Math.max(minTranslateX, Math.min(0, translateX));
      carousel.style.transform = 'translateX(' + translateX + 'px)';

      var noOverflow = totalCarouselWidth <= containerWidth;
      if (container) {
        if (centerWhenNoCarousel && noOverflow) {
          container.classList.add('columbia-carrusel-text-img-carousel-container--centered');
        } else {
          container.classList.remove('columbia-carrusel-text-img-carousel-container--centered');
        }
      }

      updateDotsMobile();
      renderDesktopDots();
      updateArrows();
    }

    function goToSlide(index) {
      if (index < 0) index = 0;
      if (index >= totalSlides) index = totalSlides - 1;

      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        currentIndex = index;
        updateCarousel();
        return;
      }

      const maxIndex = getMaxIndex();
      if (index > maxIndex) index = maxIndex;
      currentIndex = index;
      updateCarousel();
    }

    if (dotsContainerMobile) {
      dotsContainerMobile.addEventListener('click', function(e) {
        var dot = e.target.closest('.columbia-carrusel-text-img-dot-mobile');
        if (dot) {
          var slideIndex = parseInt(dot.getAttribute('data-slide-index'), 10);
          goToSlide(slideIndex);
        }
      });
    }

    if (arrowLeft) {
      arrowLeft.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (currentIndex > 0) goToSlide(currentIndex - 1);
      });
    }
    if (arrowRight) {
      arrowRight.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var maxIndex = getMaxIndex();
        if (currentIndex < maxIndex) goToSlide(currentIndex + 1);
      });
    }

    var isDragging = false;
    var justDragged = false;
    var startX = 0;
    var currentX = 0;
    var baseTranslateX = 0;

    var container = carousel.closest('.columbia-carrusel-text-img-carousel-container') || carousel;
    var touchJustDragged = false;

    if (container) {
      container.addEventListener('click', function(e) {
        var onLink = e.target.closest('a.columbia-carrusel-text-img-slide-link');
        if (onLink && (justDragged || touchJustDragged)) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    function initMouseDrag() {
      if (window.innerWidth <= 768) return;
      var containerEl = carousel.closest('.columbia-carrusel-text-img-carousel-container') || carousel;
      if (!containerEl) return;

      containerEl.addEventListener('mousedown', function(e) {
        if (window.innerWidth <= 768) return;
        if (e.target.closest('a.columbia-carrusel-text-img-slide-link')) return;
        isDragging = true;
        justDragged = false;
        startX = e.clientX;
        baseTranslateX = getCurrentTranslateX();
        carousel.style.transition = 'none';
        carousel.style.cursor = 'grabbing';
        containerEl.style.cursor = 'grabbing';
        e.preventDefault();
      });

      document.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        currentX = e.clientX;
        var diffX = currentX - startX;
        var newTranslateX = baseTranslateX + diffX;
        var slideWidth = (slides[0] && slides[0].offsetWidth) ? slides[0].offsetWidth : getSlideWidth();
        var gap = getGap();
        var containerWidth = getContainerContentWidth();
        var totalCarouselWidth = (totalSlides * slideWidth) + ((totalSlides - 1) * gap);
        var minTranslateX = -(totalCarouselWidth - containerWidth);
        var maxTranslateX = 0;
        if (totalCarouselWidth <= containerWidth) {
          minTranslateX = 0;
          maxTranslateX = 0;
        }
        var slideSize = slideWidth + gap;
        var dragMargin = slideSize * 0.3;
        var clampedTranslateX = Math.max(minTranslateX - dragMargin, Math.min(newTranslateX, maxTranslateX + dragMargin));
        carousel.style.transform = 'translateX(' + clampedTranslateX + 'px)';
      });

      document.addEventListener('mouseup', function(e) {
        if (!isDragging) return;
        var diffX = currentX - startX;
        if (Math.abs(diffX) > 5) justDragged = true;
        setTimeout(function() { justDragged = false; }, 100);
        isDragging = false;
        carousel.style.cursor = '';
        containerEl.style.cursor = '';
        carousel.style.transition = 'transform 0.55s cubic-bezier(0.22, 0.61, 0.36, 1)';
        var currentTranslateX = getCurrentTranslateX();
        var slideWidth = (slides[0] && slides[0].offsetWidth) ? slides[0].offsetWidth : getSlideWidth();
        var threshold = slideWidth * 0.3;
        var targetIndex;

        if (Math.abs(diffX) > threshold) {
          if (diffX > 0 && currentIndex > 0) {
            targetIndex = currentIndex - 1;
          } else if (diffX < 0) {
            var maxIndex = getMaxIndex();
            targetIndex = Math.min(currentIndex + 1, maxIndex);
          } else {
            targetIndex = currentIndex;
          }
        } else {
          targetIndex = getSlideIndexFromTranslateX(currentTranslateX);
        }
        var maxIndex = getMaxIndex();
        targetIndex = Math.max(0, Math.min(targetIndex, maxIndex));
        currentIndex = targetIndex;
        updateCarousel();
      });

      containerEl.addEventListener('mouseleave', function(e) {
        if (isDragging) {
          document.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, clientX: e.clientX, clientY: e.clientY }));
        }
      });
    }

    initMouseDrag();

    var lastWindowWidth = window.innerWidth;
    window.addEventListener('resize', function() {
      if ((lastWindowWidth <= 768 && window.innerWidth > 768) || (lastWindowWidth > 768 && window.innerWidth <= 768)) {
        initMouseDrag();
      }
      lastWindowWidth = window.innerWidth;
    });

    updateCarousel();
    if (window.innerWidth <= 768) updateDotsMobile();
    renderDesktopDots();

    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        visibleSlides = calculateVisibleSlides();
        var isMobile = window.innerWidth <= 768;
        if (isMobile && visibleSlides === 1) {
          if (currentIndex >= totalSlides) currentIndex = Math.max(0, totalSlides - 1);
        } else {
          var maxIndex = getMaxIndex();
          if (currentIndex > maxIndex) currentIndex = maxIndex;
        }
        updateCarousel();
        if (window.innerWidth <= 768) updateDotsMobile();
        renderDesktopDots();
      }, 250);
    });

    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var isDraggingTouch = false;
    var baseTranslateXTouch = 0;
    /** No usar preventDefault en toque simple: así el <a> recibe click. Solo robar el gesture si hay swipe horizontal claro. */
    var TOUCH_DRAG_COMMIT_PX = 12;

    carousel.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchEndX = touchStartX;
      isDraggingTouch = false;
      baseTranslateXTouch = getCurrentTranslateX();
      carousel.style.transition = 'none';
      touchJustDragged = false;
    }, { passive: true });

    carousel.addEventListener('touchmove', function(e) {
      var x = e.touches[0].clientX;
      var y = e.touches[0].clientY;
      var diffX = x - touchStartX;
      var diffY = y - touchStartY;

      if (!carousel.classList.contains('columbia-carrusel-text-img-touch--dragging')) {
        if (Math.abs(diffX) < TOUCH_DRAG_COMMIT_PX && Math.abs(diffY) < TOUCH_DRAG_COMMIT_PX) {
          return;
        }
        if (Math.abs(diffX) <= Math.abs(diffY)) {
          return;
        }
        isDraggingTouch = true;
        carousel.classList.add('columbia-carrusel-text-img-touch--dragging');
        touchStartX = x;
        touchStartY = y;
        baseTranslateXTouch = getCurrentTranslateX();
      }

      touchEndX = x;
      diffX = touchEndX - touchStartX;
      var newTranslateX = baseTranslateXTouch + diffX;
      var slideWidth = (slides[0] && slides[0].offsetWidth) ? slides[0].offsetWidth : getSlideWidth();
      var gap = getGap();
      var isMobile = window.innerWidth <= 768;
      var containerWidth = getContainerContentWidth();
      var minTranslateX;
      var maxTranslateX;

      if (isMobile && visibleSlides === 1) {
        maxTranslateX = 0;
        if (totalSlides > 1) {
          var lastSlideEndPosition = (totalSlides - 1) * (slideWidth + gap) + slideWidth;
          minTranslateX = containerWidth - lastSlideEndPosition;
        } else {
          minTranslateX = 0;
        }
      } else {
        var maxIndexMove = getMaxIndex();
        if (maxIndexMove === 0) {
          var currentTranslate = -(currentIndex * (slideWidth + gap));
          minTranslateX = currentTranslate;
          maxTranslateX = currentTranslate;
        } else {
          maxTranslateX = 0;
          minTranslateX = -(maxIndexMove * (slideWidth + gap));
        }
      }
      var clampedTranslateX = Math.max(minTranslateX, Math.min(newTranslateX, maxTranslateX));
      carousel.style.transform = 'translateX(' + clampedTranslateX + 'px)';
      e.preventDefault();
    }, { passive: false });

    carousel.addEventListener('touchend', function() {
      carousel.classList.remove('columbia-carrusel-text-img-touch--dragging');

      if (!isDraggingTouch) {
        carousel.style.transition = 'transform 0.55s cubic-bezier(0.22, 0.61, 0.36, 1)';
        return;
      }

      isDraggingTouch = false;
      carousel.style.transition = 'transform 0.55s cubic-bezier(0.22, 0.61, 0.36, 1)';
      var diffX = touchEndX - touchStartX;
      var slideWidth = (slides[0] && slides[0].offsetWidth) ? slides[0].offsetWidth : getSlideWidth();
      var threshold = slideWidth * 0.3;

      if (Math.abs(diffX) > 8) {
        touchJustDragged = true;
        setTimeout(function() {
          touchJustDragged = false;
        }, 350);
      }

      if (Math.abs(diffX) > threshold) {
        if (diffX > 0 && currentIndex > 0) {
          goToSlide(currentIndex - 1);
        } else if (diffX < 0 && currentIndex < totalSlides - 1) {
          goToSlide(currentIndex + 1);
        } else {
          updateCarousel();
        }
      } else {
        updateCarousel();
      }
    }, { passive: true });

    carousel.addEventListener('touchcancel', function() {
      carousel.classList.remove('columbia-carrusel-text-img-touch--dragging');
      carousel.style.transition = 'transform 0.55s cubic-bezier(0.22, 0.61, 0.36, 1)';
      if (isDraggingTouch) {
        isDraggingTouch = false;
        updateCarousel();
      }
    }, { passive: true });
  }

  function runInit() {
    document.querySelectorAll('.columbia-carrusel-text-img-carousel-wrapper[data-carousel-id]').forEach(function(carousel) {
      initCarousel(carousel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }
})();
